export default "__VITE_ASSET__d4522fbd__"